/**
 * @author      matthew@zumper.com (Matthew Talamini)
 * @copyright   Copyright (c) 2021, Zumper
 */

export const CLEAR_SHORT_TERM_AVAILABILITY =
  '@@nzr/shortTermAvailability/CLEAR_SHORT_TERM_AVAILABILITY'
export const DONE_FETCHING_SHORT_TERM_AVAILABILITY =
  '@@nzr/shortTermAvailability/DONE_FETCHING_SHORT_TERM_AVAILABILITY'
export const ERROR_FETCHING_SHORT_TERM_AVAILABILITY =
  '@@nzr/shortTermAvailability/ERROR_FETCHING_SHORT_TERM_AVAILABILITY'
export const RECEIVE_SHORT_TERM_AVAILABILITY =
  '@@nzr/shortTermAvailability/RECEIVE_SHORT_TERM_AVAILABILITY'
export const START_FETCHING_SHORT_TERM_AVAILABILITY =
  '@@nzr/shortTermAvailability/START_FETCHING_SHORT_TERM_AVAILABILITY'

export const RECEIVE_VRBO_AVAILABILITY = '@@nzr/shortTermAvailability/RECEIVE_VRBO_AVAILABILITY'
export const CLEAR_VRBO_AVAILABILITY = '@@nzr/shortTermAvailability/CLEAR_VRBO_AVAILABILITY'
export const START_FETCHING_VRBO_AVAILABILITY =
  '@@nzr/shortTermAvailability/START_FETCHING_VRBO_AVAILABILITY'
export const DONE_FETCHING_VRBO_AVAILABILITY =
  '@@nzr/shortTermAvailability/DONE_FETCHING_VRBO_AVAILABILITY'
export const ERROR_FETCHING_VRBO_AVAILABILITY =
  '@@nzr/shortTermAvailability/ERROR_FETCHING_VRBO_AVAILABILITY'
